const projects = [
  {
    id: 'soccer_mondial',
    name: 'SOCCER MONDIAL',
    short_description: `Soccer Mondial is a player agency based in Zurich. For their purposes, we have developed a CMS solution and hybrid mobile mobile apps. The CMS solution is used for the corporate website management, whereas the mobile helps players organize their calendar correspondingly to their daily activities.`,
    images: [
      require('./../assets/projects/soccer-mondial/sm-web.png'),
      require('./../assets/projects/soccer-mondial/sm-web-small.png'),
      require('./../assets/projects/soccer-mondial/sm-mobile.png'),
    ]
  },
  {
    id: 'faceclub',
    name: 'FACECLUB',
    short_description: `Faceclub solution was developed for the necessities of a night club located in Zurich. Faceclub solution consists of 3 different systems: CMS, booking and orders platform. Faceclub corporate website is managed from the CMS admin panel. Booking platform is connected with the client websites and aims to ease the reservations management in the club. On the booking platform, the admin can oversee all reservations being made in the club. Guests visiting the club order and pay for their drinks by using the mobile adapted web application called Faceclub orders.`,
    images: [
      require('./../assets/projects/faceclub/faceclub-web.png'),
      require('./../assets/projects/faceclub/faceclub-web-small.png'),
      require('./../assets/projects/faceclub/faceclub-mobile.jpg')
    ]
  },
  {
    id: 'faceshop',
    name: 'STEVEN DOCKMAN CH',
    short_description: `Steven Dockman is a custom-made e-shop for clothing. The solution is built with a focus on ease of use, so that customers are able to find desired products with just a few clicks.
The solution is comprised of an admin panel and client website. The admin is used for managing the clothes that Steven Dockman sales, whilst the client site is used by the customers for buying products.
`,
    images: [
      require('./../assets/projects/faceshop/faceshop-web.png'),
      require('./../assets/projects/faceshop/faceshop-web-small.png'),
      require('./../assets/projects/faceshop/faceshop-mobile.png')
    ]
  },
  {
    id: 'departmentware',
    name: 'DEPARTMENTWARE - USA',
    short_description: `
    Departmentware mission is to provide helpful software solutions that streamline the processes in public safety while simultaneously mitigating risk and lowering costs.

The FTO platform is an affordable and tailor-made cloud-based solution, which digitalizes the Field Training Officer program. The solution provides numerous benefits of all affected personnel - from trainee to command staff by making sure that the appropriate documentation is easily accessible when needed.

Quartermaster platform helps users manage the inventory utilizing Q.R. codes, serial numbers, descriptions or a bevy of other tracking mechanisms. The users are able to keep track of their inventory, check inventory in and out and create notifications where needed. Quartermaster controls min/max inventory levels easily and traces costs to manage budget cycles.
`,
    images: [
      require('./../assets/projects/faceshop/faceshop-web.png'),
      require('./../assets/projects/faceshop/faceshop-web-small.png'),
      require('./../assets/projects/faceshop/faceshop-mobile.png')
    ]
  },
  {
    id: 'bakalnica',
    name: 'BAKALNICA',
    short_description: `
Bakalnica is an e-commerce solution for local supermarket foodstore. Bakalnica emphasizes simplicity above all, and it’s simple and clean design makes it appropriate for customers from different age groups. The solution was developed as a result of the increased market needs during the Corona virus outbreak. 

Bakalnica is comprised of an admin panel and client website. The admin is used for managing the products that the supermarket offers whilst the client website is where the orders are being made by the customers.
`,
    images: [
      require('./../assets/projects/faceshop/faceshop-web.png'),
      require('./../assets/projects/faceshop/faceshop-web-small.png'),
      require('./../assets/projects/faceshop/faceshop-mobile.png')
    ]
  },
];

module.exports = {
  projects
}
